import React, { useEffect, useState } from "react";

const CustomToolbar = (toolbar) => {
  const [currentRange, setCurrentRange] = useState("");
  const [activeView, setActiveView] = useState(toolbar.view || "week");

  const calculateDateRange = () => {
    const date = new Date(toolbar.date);
    if (toolbar.view === "week") {
      const start = new Date(date.setDate(date.getDate() - date.getDay()));
      const end = new Date(start);
      end.setDate(end.getDate() + 6);
      setCurrentRange(
        `${start.toLocaleDateString("en-US", { month: "short", day: "numeric" })} – ${end.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`
      );
    } else if (toolbar.view === "month") {
      setCurrentRange(date.toLocaleDateString("en-US", { year: "numeric", month: "long" }));
    } else {
      setCurrentRange(date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }));
    }
  };

  useEffect(() => {
    calculateDateRange();
    setActiveView(toolbar.view);
  }, [toolbar.date, toolbar.view]);

  const goToBack = () => toolbar.onNavigate("PREV");
  const goToNext = () => toolbar.onNavigate("NEXT");
  const goToToday = () => toolbar.onNavigate("TODAY");

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
      <div className="flex flex-wrap gap-1">
        {["week", "day", "month"].map((view) => (
          <button
            key={view}
            onClick={() => { setActiveView(view); toolbar.onView(view); }}
            className={`px-3 py-1.5 text-sm font-medium rounded-lg capitalize transition ${
              activeView === view
                ? "bg-indigo-600 text-white shadow-sm"
                : "text-gray-700 hover:bg-gray-100"
            }`}
          >
            {view}
          </button>
        ))}
      </div>
      <div className="text-sm font-semibold text-gray-700">{currentRange}</div>
      <div className="flex items-center gap-1">
        <button onClick={goToBack} className="p-1.5 rounded-full hover:bg-gray-100 transition">
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button onClick={goToToday} className="p-1.5 rounded-full hover:bg-gray-100 transition">
          <span className="text-sm font-medium text-gray-600">Today</span>
        </button>
        <button onClick={goToNext} className="p-1.5 rounded-full hover:bg-gray-100 transition">
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CustomToolbar;